import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Checkbox,
  Button,
  Modal,
  Icon,
  Select,
  Message,
} from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import Validator from 'validatorjs';
import {
  RETURN_CANCELATION_REASONS,
  CANCELLATION_NOTE_LAST_PART,
} from '../../constants';
import REGEX from '../../constants/regexPatterns';

class ReturnInvoiceCancel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showReturn: false,
      showWarning: false,
      returnInvoiceId: null,
      cancelationReason: null,
      reason: null,
      sendEmail: false,
      userEmail: '',
      errors: {},
    };
  }

  componentDidMount() {
    const { returnInvoice } = this.props;
    const { id, transaction: { vehicleReceived } } = returnInvoice;

    this.setState({ returnInvoiceId: id });
    this.setState({
      showWarning: vehicleReceived,
      showReturn: !vehicleReceived,
    });
  }

  render() {
    const {
      returnInvoice,
      isCancelModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
    } = this.props;

    const {
      errors, reason, showWarning, showReturn, cancelationReason, sendEmail, userEmail,
    } = this.state;

    const onSelectHandler = field => (event, data) => {
      this.setState({ [field]: data.value });
      this.setState({ reason: data.value });
    };

    const onCheckboxHandler = field => (event, data) => {
      this.setState({ [field]: data.checked });
    };

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
    };

    const validationRules = {
      cancelationReason: 'required',
      reason: 'required',
      userEmail: [
        { required_if: ['sendEmail', true] },
        'regex:' + REGEX.MULTIPLE_EMAILS,
      ],
    };

    const submitForm = () => {
      const {
        returnInvoiceId,
      } = this.state;

      const validation = new Validator(this.state, validationRules);

      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      onSubmitHandler({
        returnInvoiceId,
        cancellation: {
          cancelationReason: reason,
          sendEmail,
          userEmail,
        },
      });
      this.setState({ errors: {} });
      return true;
    };

    const { transaction: { vin }, status } = returnInvoice;
    const cancellationNote = isEmpty(reason)
      ? null
      : reason + ', ' + CANCELLATION_NOTE_LAST_PART;
    const isCancelling = status === 'cancelling';
    const isNotAllowedToCancel = isCancelling;
    const openCancelModal = isCancelModalOpen && showReturn;
    return (
      <div>
        <Modal open closeOnEscape={false} closeOnRootNodeClick={false}>
          <Modal
            open={showWarning}
            closeOnEscape={false}
            closeOnRootNodeClick={false}
          >
            <Modal.Header>Cancel Return Invoice for VIN {vin}</Modal.Header>
            <Modal.Content image>
              <Modal.Description>
                <Message negative>
                  <p>
                    <strong>
                      This Vehicle Has Already Been Received At The Auction.
                    </strong>
                  </p>
                </Message>
              </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
              {showWarning && (
              <Button onClick={onCloseHandler}>Cancel</Button>
              )}
            </Modal.Actions>
          </Modal>

          <Modal
            open={openCancelModal}
            closeIcon
            onClose={onCloseHandler}
            closeOnEscape={false}
            closeOnRootNodeClick={false}
          >
            <Modal.Header>Cancel Return Invoice for VIN {vin}</Modal.Header>
            {isNotAllowedToCancel && (
              <Modal.Content image>
                <Modal.Description>
                  <Message negative>
                    <p>
                      {isCancelling
                        ? 'This return is cancelling.'
                        : 'This vehicle has been received at auction, hence this return cannot be cancelled.'}
                    </p>
                  </Message>
                </Modal.Description>
              </Modal.Content>
            )}
            {!isNotAllowedToCancel && (
              <Modal.Content image scrolling>
                <Modal.Description>
                  {error && (
                    <Message negative>
                      <p>{error}</p>
                    </Message>
                  )}
                  <Form>
                    <Form.Group widths='equal'>
                      <Form.Field
                        required
                        error={!isEmpty(errors.cancelationReasons)}
                      >
                        <Select
                          placeholder='Select cancellation reason'
                          options={RETURN_CANCELATION_REASONS}
                          closeOnBlur
                          value={cancelationReason}
                          onChange={onSelectHandler('cancelationReason')}
                        />
                        {errors.cancelationReason && (
                          <span className='error-text'>{errors.cancelationReason}</span>
                        )}
                      </Form.Field>
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Form.Field required error={!isEmpty(errors.reason)}>
                        <label htmlFor='reason'>Reason</label>
                        <input
                          id='reason'
                          label='Reason'
                          name='reason'
                          value={reason}
                          onChange={onChangeHandler('reason')}
                        />
                        {!errors.cancelationReason
                          && errors.reason && <span className='error-text'>{errors.reason}</span>}
                      </Form.Field>
                    </Form.Group>
                    <Form.Group>
                      {cancellationNote && (
                        <Message Floating>
                          <Message.Header>
                            The user will see the following:
                          </Message.Header>
                          <br />
                          <p>{cancellationNote}</p>
                        </Message>
                      )}
                    </Form.Group>
                    <Form.Group widths='equal'>
                      <Form.Field error={!isEmpty(errors.userEmail)}>
                        <Checkbox
                          label='Send cancellation email?'
                          checked={sendEmail}
                          onChange={onCheckboxHandler('sendEmail')}
                        />
                        <label htmlFor='userEmail'>Email</label>
                        <input
                          id='userEmail'
                          label='Email'
                          name='email'
                          value={userEmail}
                          onChange={onChangeHandler('userEmail')}
                        />
                        {errors.userEmail && <span className='error-text'>{errors.userEmail}</span>}
                      </Form.Field>
                    </Form.Group>
                  </Form>
                </Modal.Description>
              </Modal.Content>
            )}
            {!isNotAllowedToCancel && (
              <Modal.Actions>
                {submitting && (
                  <Button loading positive>
                    Submitting...
                  </Button>
                )}
                {!submitting && (
                  <Button color='green' onClick={submitForm} inverted>
                    <Icon name='checkmark' /> Submit
                  </Button>
                )}
                <Button onClick={onCloseHandler}>Cancel</Button>
              </Modal.Actions>
            )}
          </Modal>
        </Modal>
      </div>
    );
  }
}

ReturnInvoiceCancel.propTypes = {
  returnInvoice: PropTypes.shape({
    id: PropTypes.number,
    transaction: PropTypes.shape({
      vehicleReceived: PropTypes.bool,
      vin: PropTypes.string,
    }),
    status: PropTypes.string,
  }).isRequired,
  isCancelModalOpen: PropTypes.bool.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  onSubmitHandler: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitting: PropTypes.bool.isRequired,
};

export default ReturnInvoiceCancel;
